// extracted by mini-css-extract-plugin
module.exports = {"marker":"Marker_marker__1DrFt","logo":"Marker_logo__1Wxhd"};